import './recommendedCompanyCard.css';
import backgroundImage from "./gourmet-card.png";
import { locationIcon, shopIcon, scheduleIcon, chefHatIcon } from "../../../utils/icons";
import { Link, useNavigate } from 'react-router-dom';
import useSendProfileToCompany from '../../../hooks/useSendProfileToCompany';
import { useAuth } from '../../../context/AuthContext';

const RecommendCompanyCard = ({ data }) => {
  const navigate = useNavigate();
  const { isAuthenticated, userInfo, logout } = useAuth(); 
  const { isLoading, error, successMessage, createTalentPoolRecord, isCvSent } = useSendProfileToCompany(data.id);

  const handleApplyRedirect = () => {
    navigate(`/trabajos/${data.id}`); 
  };

  const profileImage=data.profileImageUrl

  const handleCompanyClick = () => {
    navigate(`/empresas/${data.id}`); 
  };

  const handleSendProfile = async () => {
    if (!isAuthenticated) {
      navigate('/profesionales/entrar'); 
      return;
    }

    try {
      createTalentPoolRecord();
    } catch (error) {
      console.error('Error sending profile:', error.message);
    }
  };

  const handleLocationDisplay = () => {
    if (data.comune === undefined) {
      return data.region;
    }
    return `${data.region}, ${data.comune}`;
  };

  return (
    <>
      <div className="recommended-company-card__container">
        <div className="recommended-company-card__image-container">
          <img className="recommended-company-card__brackground-image" src={backgroundImage} alt="Background" />
          <img className="recommended-company-card__image" src={profileImage} alt="Avatar" />
        </div>
        <div className="recommended-company-card__details-container">
          <h1>{data.name}</h1>
          <div className="recommended-company-card__information-container">
            <div className="recommended-company-card__icon-title-container">
              {shopIcon}
              <div className="recommended-company-card__info-label-container" >
                 <p><strong>Establecimiento:</strong></p>
                 <p>{data.format}</p>
              </div>
            </div>
            <div className="recommended-company-card__icon-title-container">
              {locationIcon}
              <div className="recommended-company-card__info-label-container">
                <p><strong>Ubicación:</strong></p>
                <p className="recommended-company-card__truncate-text">{handleLocationDisplay()}</p>
              </div>
            </div>
            <div className="recommended-company-card__icon-title-container">
              {chefHatIcon}
              <div className="recommended-company-card__info-label-container">
                <p><strong>Especialidad:</strong></p>
                <p>{data.specialty}</p>
              </div>
            </div>
          </div>
          <div className="recommended-company-card__buttons-container">
            <button className="recommended-company-card__button" onClick={handleCompanyClick}>
              Perfil
            </button>
            
            <button 
              onClick={handleSendProfile} 
              className="recommended-company-card__button"
            >
              {isCvSent ? 'Enviado' : 'Enviar CV'}
            </button>

          </div>
        </div>
      </div>
    </>
  );
};

export default RecommendCompanyCard;